<template>
  <div class="main-container" :style="mainCssVars">
    <grid class="grid--container">
      <grid-item>
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1.5"
        >
          <div
            class="half-text-container"
            :style="mainCssVars"
            :class="[cms.align === 'left' ? 'left-align' : 'right-align']"
          >
            <div v-if="cms.text" v-html="$options.filters.markdown(cms.text)" />
            <div v-if="cms.showCta" style="margin-top: 40px">
              <a :href="cms.ctaUrl" class="cta">{{ cms.ctaText }}</a>
            </div>
          </div>
        </SlideInView>
      </grid-item>
    </grid>
  </div>
</template>
<script>
export default {
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.cms.backgroundColor || 'white',
        '--text-color': this.cms.fontColor || 'black',
        '--cta-text-color': this.cms.ctaFontColor || 'white',
        '--cta-bg-color': this.cms.ctaBackgroundColor || 'black',
        '--padding-bottom': this.cms.paddingBottom || '120px',
        '--padding-top': this.cms.paddingTop || '120px',
        '--padding-bottom-mobile': this.cms.paddingBottomMobile || '64px',
        '--padding-top-mobile': this.cms.paddingTopMobile || '64px',
        '--max-width': this.cms.maxWidth || '50%',
      }
    },
  },
}
</script>

<style lang="scss">
.half-text-container {
  h1 {
    margin: 0;
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.main-container {
  background-color: var(--bg-color);
  color: var(--text-color);
  margin: 0;
  padding: 0;
  padding-top: var(--padding-top-mobile);
  padding-bottom: var(--padding-bottom-mobile);
}

.half-text-container {
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 35px */

  h1 {
    margin: 0;
    padding: 0;
  }

  ::v-deep a {
    text-decoration: underline;
    cursor: pointer;
  }

  ::v-deep a:hover {
    color: #ff3476;
  }

  ::v-deep p {
    font-size: 20px !important;
  }
}

.cta {
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 20px */
  min-width: 131px;
  min-height: 44px;
  border-radius: 22px;
  background: var(--cta-bg-color);
  color: var(--cta-text-color);
  padding: 12px 32px;
}

@include media-breakpoint-up(md) {
  .left-align {
    float: left;
    max-width: var(--max-width);
  }
  .right-align {
    float: right;
    max-width: var(--max-width);
  }

  .main-container {
    margin: 0;
    padding: 0;
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);
  }

  .half-text-container {
    ::v-deep p {
      font-size: 24px !important;
    }
  }
}
</style>
